import React, { useCallback } from 'react';

import { Text } from '../../texts';
import Waves from '../../waves';
import { Styled } from './styled';

export const InputButton = (props) => {
  const {
    text,
    isDisable,
    onClick,
    classNameWaves,
    error,
  } = props;
  const buttonOnClick = useCallback(
    (e) => {
      e.stopPropagation();
      !isDisable && onClick(e);
    },
    [isDisable, onClick]
  );

  return (
    <Styled.InputButton
      isDisable={isDisable}
      error={error}
      onClick={buttonOnClick}
    >
      <Waves
        color={isDisable ? 'white' : 'turquoise'}
        className={classNameWaves}
      />
      <Text>{text}</Text>
    </Styled.InputButton>
  );
};
